export const defaultGiftCardPaymentFormCardNumberFieldDisplayText = {
    label: 'Enter a card number',
    placeholder: 'Enter a card number',
    requiredMessage: 'You must enter a card number.',
    lengthMessage: 'Your card number must be at least ${minLength} characters long.',
    formatMessage: 'Your card number contains invalid characters.'
};
export const defaultGiftCardPaymentFormPinFieldDisplayText = {
    label: 'PIN',
    placeholder: 'PIN',
    requiredMessage: 'You must enter a PIN.',
    lengthMessage: 'A valid gift card PIN must be between ${minLength} and ${maxLength} characters.',
    formatMessage: 'A gift card PIN only contains numbers.'
};
